
import { useState } from "react";
import { usePrescriptionCart } from "../../../context/pharmacy/PrescriptionCartContext";
import PrescriptionCartStep1 from "./PrescriptionCartStep1";

export default function PrescriptionCart() {
  const { items } = usePrescriptionCart();

  const [step, setStep] = useState(1);
  const [orderData, setOrderData] = useState({
    address: null,
    comment: "",
  });

  const handleStep1Continue = (data) => {
    setOrderData(data);
    setStep(2);
  };

  return (
    <div className="prescription-cart-page">
      {step === 1 && (
        <PrescriptionCartStep1
          items={items}
          onAddressSelected={(address) => {
            setOrderData((prev) => ({ ...prev, address }));
          }}
          onContinue={handleStep1Continue}
          onBack={() => window.history.back()}
        />
      )}

      {step === 2 && (
        <div>
          {/* Your Step 2 payment/order summary component */}
          <h2>مرحله دوم</h2>
          <p>آدرس: {orderData.address?.address}</p>
          <p>تعداد سفارش‌ها: {orderData.items?.length || 0}</p>
        </div>
      )}
    </div>
  );
}
